import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ReportsPage = lazy(() => import('./reports-page').then((m) => ({ default: m.ReportsPage })));

export const reportRoutes: RouteObject[] = [{ path: 'reports', element: <ReportsPage />, handle: { crumb: 'Analytics & Reporting' } }];
